<script setup>
import down from "@/assets/img/down.png"
let zhichilun = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/product/zhichilun.png"
let product_1 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/productCenter_1.jpg"
import {onMounted, ref} from "vue";
import jsonData from '@/assets/product.json';
import {getImagePath} from '@/utils/utils'

const submenuStyle = ref({
      1: {
        "menu": {
          backgroundColor: 'white',
          color: '#7f7f7f'
        },
        "submenu": {
          "color": 'rgba(0,0,0,0.5)',
          "font-size": '1rem'

        }
      },
      2: {
        "menu": {
          backgroundColor: 'white',
        },
        "submenu": {
          "color": 'rgba(0,0,0,0.7)',
          "font-size": '1rem'


        }
      }
    }
);



const pictures = ref([{
  "img_url": zhichilun
}, {
  "img_url": zhichilun
}, {
  "img_url": zhichilun
}, {
  "img_url": zhichilun
}, {
  "img_url": zhichilun
}, {
  "img_url": zhichilun
}
])

function handleOpen(key) {
  submenuStyle.value[key].menu.backgroundColor = '#005db6'
  submenuStyle.value[key].submenu.color = 'white'

}

function handleClose(key) {
  submenuStyle.value[key].menu.backgroundColor = 'white'
  submenuStyle.value[key].submenu.color = 'rgba(0,0,0,0.7)'


}// 创建响应式数据
const menuItems = ref([]); // 默认菜单项

const loadImages = (key) => {

  if (jsonData[key]) {
    const img_urls = []
    console.log(jsonData[key])
    jsonData[key].forEach(value => {
      let img_path = getImagePath(value.path,"product")
      img_urls.push({
        "img_url": img_path,
        "desc": value.desc,
        "name": value.name,
        "material": value.material,
        "teeth_count": value.teeth_count,
        "teeth_width": value.teeth_width
      })
    })
    pictures.value = img_urls; // 更新当前显示的图片数组
  }
};
const loadJsonData = () => {
  try {
    // 循环 jsonData 的每个键（key），并将它们追加到 menuItems
    for (const key in jsonData) {
      menuItems.value.push(key); // 这里把每个键追加到 menuItems 中

    }
  } catch (error) {
    console.error("读取 JSON 文件失败:", error);
  }
};

onMounted(() => {
  loadJsonData();
  loadImages(menuItems.value[0])
});

</script>

<template>
  <div>
    <div class="first-picture-font">
      <div class="gothamBold">
        PRODUCT CENTER
      </div>
      <div class="puHuiTi-Medium" style="font-size: 1.5rem;font-weight: lighter">
        产品中心
      </div>

      <el-image
          style="height: 2.5rem;padding-top: 0.8rem;  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */"
          :src="down" fit="cover"/>
    </div>
    <div style="background-color: rgb(243.9, 244.2, 244.8);">

      <el-image
          style="width: 100%;height: 22rem"
          :src="product_1"
          fit="cover"
      />
      <el-row style="position: relative">
        <div style="text-align: left;margin-left: 5%;width: 95%;margin-top: 2rem" class="gothamBold">
          <span class="company_font_blue" style="font-size: 2rem;">P<span style="color: #aaaaaa">RODUCT</span> </span>
          <br>
        </div>
        <el-affix :offset="120" class="menu">
          <div style="border: white 1px solid">
            <el-menu
                default-active="1-1"
                background-color="#ffffff"
                text-color="#7f7f7f"
                active-text-color="#409EFF"
                @open="handleOpen"
                @close="handleClose"
            >
              <el-sub-menu index="1" class="puHuiTi-Medium" :style="submenuStyle[1].menu">
                <template #title>
                  <span :style="submenuStyle[1].submenu">产品</span>
                </template>
                <el-menu-item
                    v-for="(item, index) in menuItems"
                    :key="index"
                    :index="'1-' + (index + 1)"
                    @click="loadImages(item)"
                >
                  {{ item }}
                </el-menu-item>
              </el-sub-menu>
            </el-menu>

          </div>
        </el-affix>
        <el-col :offset="6" :span="14" style="margin-top: 0.8rem;text-align: right;position: relative">
          <el-image
              style="height: 16rem;width:16rem;text-align:left;position: absolute;left: 0;bottom: 0"
              :src="zhichilun"
              fit="fill"
          />
          <span class="gothamBold" style="font-size: 2rem;color: #aaaaaa">Helical &nbsp;<span class="company_font_blue">Gear</span> </span>
          <div style="height: 14rem;background-color: #cecece;margin-top: 0.8rem">
            <div style="margin-left:60%;width: 40%">
              <div class="puHuiTi-Medium"
                   style="font-size: 2rem;padding-top: 1.2rem;margin-right: 1.2rem;">
                斜齿<span
                  style="border-bottom: #005db6 4px solid;padding-bottom: 0.5rem">轮</span></div>
              <div class="puHuiTi-regular"
                   style="margin-top: 1.2rem;margin-right: 1.2rem;line-height: 1.5rem;font-size: 1rem">
                高精度齿轮加工技术将有效提高齿轮的精度和质量，降低齿轮的噪音和振动，提升齿轮的传动效率。
              </div>
              <div>
                <el-button class="know-button puHuiTi-Medium">了解一下</el-button>
              </div>
            </div>

          </div>


        </el-col>

      </el-row>

      <el-row>
        <el-col
            v-for="(row, rowIndex) in pictures" :key="rowIndex"
            :offset="rowIndex%3 === 0 ? 6 : 1"
            :span="4"
            style="text-align: left;margin-top: 1.2rem"
        >
          <div style="background-color: #aaaaaa;margin-top: 2rem;">
            <el-image
                style="width: 100%;"
                :src="row.img_url"
                fit="cover"
            />
          </div>

          <div>
            <el-row>
              <el-col :span="8" class="puHuiTi-Medium" style="margin-top: 0.8rem;color: #7f7f7f;">
                材质：{{ row.material }}
              </el-col>
              <el-col :span="16" style="color:#b7b7b7;text-align: right;margin-top: 0.8rem;margin-bottom: 2.5rem">
                齿数：{{ row.teeth_count }} 齿宽：{{ row.teeth_width }}
              </el-col>
            </el-row>
          </div>

        </el-col>
<!--        <div style="width: 100%">-->
<!--          <el-pagination background layout="prev, pager, next" :total="1000"/>-->
<!--        </div>-->


      </el-row>


    </div>

  </div>

</template>

<style scoped>
.el-menu {
  border-right: none !important;
}

.el-menu-item.is-active {
  color: #005db6 !important;
}

.menu {
  width: 15%;
  top: 8rem;
  position: absolute;
  left: 5%;
  z-index: 10;
}

.know-button {
  width: 10rem;
  margin-top: 1.2rem;
  background-color: #005bd6;
  height: 2.5rem;
  color: white;
  margin-right: 1.2rem;
}


</style>